import { forwardRef } from "react";
//import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import TextField from '@mui/material/TextField';

import { DatePicker, Space } from "antd";

const UBKDate = forwardRef(({ ...rest }, ref) => (
  <div className="form-group">
    <div>
      <label className={`labelfont ${rest.classnme?rest.classnme:""}`}>{rest.Desplay}</label>
    </div>
    {/* <input className="form-group" type="date" required {...rest} ref={ref}/> */}
    <DatePicker className="form-group" required {...rest} ref={ref}  /> 
  </div>
));

export default UBKDate;
